const IMAGE_DISPLAYS = {
  big: {
    'mobile-s': { w: 164, h: 100 },
    'mobile-m': { w: 300, h: 200 },
    'mobile-l': { w: 360, h: 200 },
    'tablet-p': { w: 571, h: 496 },
    'tablet-l': { w: 655, h: 496 },
    'desktop': { w: 680, h: 516 }
  },
  small: {
    'mobile-s': { w: 164, h: 100 },
    'mobile-m': { w: 300, h: 200 },
    'mobile-l': { w: 360, h: 200 },
    'tablet-p': { w: 277, h: 210 },
    'tablet-l': { w: 320, h: 210 },
    'desktop': { w: 320, h: 220 }
  },
  thumb: {
    'default': { w: 99, h: 99 }
  }
}

export const getSiteFromUrl = (url, defaultSite = 'us') => {
  if (url) {
    const fragments = url.split('/')
    if (fragments.length < 5) return defaultSite
    if (['us', 'cl', 'pe', 'mx', 'br', 'co', 'cn'].includes(fragments[4].substr(0, 2))) {
      return fragments[4].substr(0, 2)
    }
    return defaultSite
  }
  return defaultSite
}

export const getSite = () => getSiteFromUrl(window.location.href)

export const siteToLang = site => {
  if (['cl', 'pe', 'mx', 'co'].includes(site)) return 'es'
  if (site === 'us') return 'en'
  if (site === 'br') return 'pt'
  if (site === 'cn') return 'zh'
  return 'en'
}

export const getLang = () => siteToLang(getSite())

export const getSiteAndLang = () => {
  const site = getSite()
  const locale = siteToLang(site)
  return { site, locale }
}

const getImageDimensions = (url, isBig, device) => (
  url.match('thumb_jpg') ? IMAGE_DISPLAYS.thumb['default'] : (isBig ? IMAGE_DISPLAYS.big[device] : IMAGE_DISPLAYS.small[device])
)

export const setSnoopyUrl = ({
  url = '',
  device = 'desktop',
  isBig = false,
  isRetina = false,
  crop = true
}) => {
  if (url === '') return url

  const { w, h } = getImageDimensions(url, isBig, device)
  const width = isRetina ? w * 2 : w
  const height = isRetina ? h * 2 : h

  const paramSign = url.match(/\?/) ? '&' : '?'
  const imgParams = `${paramSign}format=webp&width=${width}&height=${height}&crop=${crop}`
  return url
    .replace('images.adsttc.com', 'snoopy.archdaily.com/images/archdaily')
    .replace('neufert-cdn.archdaily.net', 'snoopy.archdaily.com/images/archdaily/catalog') + imgParams
}
